import { useEditorFile } from "../../../../../hooks/useEditorFile";
import { useContext, useState } from "react";
import { DxmlBreakTableBodyContext } from "../../../../../contexts";
import DxmlElements from "../DxmlElements";

export default function DxmlTable({ editorTable }) {
    const { getChildItemsToShow, getKeyById } = useEditorFile();
    const { handleContextMenu } = useContext(DxmlBreakTableBodyContext) || {};

    return (
        <>
            <table style={editorTable.ReactCssStyle} onContextMenu={(e) => {
                handleContextMenu && handleContextMenu(e, editorTable)
            }}>
                <colgroup>
                    {
                        editorTable.EditorTableColGroup.Items.map((editorTableCol) => (
                            <col key={getKeyById(editorTableCol)} span="1" style={editorTableCol.ReactCssStyle}></col>
                        ))
                    }
                </colgroup>

                <tbody>
                    {editorTable.Items.map((editorTableRow) => (
                        <tr key={getKeyById(editorTableRow)}>
                            {editorTableRow.Items.map((editorTableColumn) => (
                                <td key={getKeyById(editorTableColumn)} style={editorTableColumn.ReactCssStyle}>
                                    <DxmlElements editorBaseModel={editorTableColumn} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}